import { useQuery } from "@tanstack/react-query";
import { useCheckoutParams, CheckoutOptions } from "../payment/checkoutUtils";
import { checkResponseStatus } from "@/lib/utils/responseChecker";
import i18n from "i18next";

const useUnauthenticatedCheckout = (
  pathname: string,
  options?: CheckoutOptions
) => {
  const { buildCheckoutUrl, buildHeaders } = useCheckoutParams();

  return useQuery<string, Error, string>({
    queryKey: ["checkout", "unauthenticated", { pathname, options }],
    queryFn: async () => {
      const url = buildCheckoutUrl(pathname, options);
      const headers = buildHeaders();

      const response = await fetch(url, { headers });
      checkResponseStatus(
        response,
        i18n.getFixedT?.(null, ["errors"]) || (i18n.t.bind(i18n) as any),
        { context: "payment.checkout" }
      );

      return response.json();
    },
    enabled: options?.enabled,
  });
};

export default useUnauthenticatedCheckout;
